<div class="avgVotingComponent" #divcontainer>
  <table class="contentTable">
    <tr>
      <td class="contentColumn">

          <h2 [translate]="'widgets.teamMood.averageVoting'">Average Voting</h2>

          <div *ngIf="isLoaded; else loadingBlock" class="questionaryContent">
            <div *ngIf="showAvg; else noDataBlock">
              <div *ngFor="let question of avgQuestionRatings">
                <label>{{question['questionName']}}</label>
                <star-rating [value]="question['avg']" [totalstars]="5" checkedcolor="gold" uncheckedcolor="grey" size="36px" readonly="true"></star-rating>
              </div>
            </div>
          </div>
          <ng-template #noDataBlock style="margin: auto;">
            <h3 [translate]="'widgets.teamMood.noVotesYet'">No votes yet!</h3>
          </ng-template>

          <ng-template #loadingBlock class="questionaryContent" style="margin: auto;">
            <h3  class="loading-cont" [translate]="'widgets.teamMood.dataLoadAnim'">Loading<span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span></h3>
          </ng-template>
      </td>
      <td class="navigationColumn">
        <svg id="navigateVotingAvgRight" class="nav-arrow">
          <path d="M-0.000175476 116L1.41383 118.828L31.1218 59.4141L1.41383 0.00012207L-0.000175476 2.82813L28.2928 59.4141L-0.000175476 116Z"/>
        </svg>
      </td>
    </tr>
  </table>
  <div class="addButtonFooter">
    <button mat-fab color="accent" placement="top" type="button" class="btn btn-success add-button" (click)="newVote()" [translate]="'widgets.teamMood.newVote'">
      <mat-icon aria-hidden="false">add</mat-icon>
    </button>
  </div>
</div>
